import type { IMyClient } from '@/entities/my-clients-entity';
import TgSvg from './tg-svg';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { socket } from '@/api/socket';
import { SOCKET_EVENTS } from '@/api/socket-events';

export default function SelectTgStatus({ client }: { client: IMyClient }) {
	function handleChangeStatus(value: string) {
		if (!socket) return;
		socket.emit(SOCKET_EVENTS.clientChangeTgStatus, { clientId: client.id, status: value });
	}

	return (
		<Select value={client.tgStatus} defaultValue={client.tgStatus} onValueChange={handleChangeStatus}>
			<SelectTrigger className='w-[70px] max-h-[39px]'>
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				<SelectItem value='notset'>
					<TgSvg size={15} fill='var(--chart-2)' /> Не использован
				</SelectItem>
				<SelectItem value='used'>
					<TgSvg size={15} fill='var(--tg-blue)' />
					Использован
				</SelectItem>
				<SelectItem value='woutcode'>
					<TgSvg size={15} fill='var(--chart-3)' /> Нет кода
				</SelectItem>
				<SelectItem value='2fa'>
					<TgSvg size={15} fill='var(--chart-5)' />
					2FA
				</SelectItem>
			</SelectContent>
		</Select>
	);
}
